export const APP_SETTINGS_NAMESPACE = 'appSettings';

export const MutationTypes = {
  SET_APP_DIGITAL_SETTINGS: 'SET_APP_DIGITAL_SETTINGS',
};

export const ActionTypes = {
  GET_APP_DIGITAL_SETTINGS: 'GET_APP_DIGITAL_SETTINGS',
};
